import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectors } from 'app-webtech-core';

const eventCreator = (region, consentID) => `${region}_C${consentID}`;
const shouldEventTrigger = (event) => !window.dataLayer.find((i) => i.event === event);

const pushEvents = (region, consentSettings) => {
  const { targeting, performance, functional, social } = consentSettings;
  const strictlyNecessaryEvent = eventCreator(region, 1);
  if (shouldEventTrigger(strictlyNecessaryEvent)) {
    window.dataLayer.push({ event: strictlyNecessaryEvent });
  }
  const performanceEvent = eventCreator(region, 2);
  if (performance && shouldEventTrigger(performanceEvent)) {
    window.dataLayer.push({ event: performanceEvent });
  }
  const functionalEvent = eventCreator(region, 3);
  if (functional && shouldEventTrigger(functionalEvent)) {
    window.dataLayer.push({ event: functionalEvent });
  }
  const targetingEvent = eventCreator(region, 4);
  if (targeting && shouldEventTrigger(targetingEvent)) {
    window.dataLayer.push({ event: targetingEvent });
  }
  const socialEvent = eventCreator(region, 5);
  if (social && shouldEventTrigger(socialEvent)) {
    window.dataLayer.push({ event: socialEvent });
  }
};

function RegionBasedGTMTrigger({ marketingRegion, consentSettings }) {
  if (marketingRegion !== undefined && consentSettings.targeting !== null) {
    const usaEvent = 'USA';
    const latamEvent = 'LATAM';
    if (!window.dataLayer.find((i) => i.marketingRegion !== undefined)) {
      window.dataLayer.push({ marketingRegion });
    }
    if (marketingRegion === 'us' && shouldEventTrigger(usaEvent)) {
      window.dataLayer.push({ event: usaEvent });
    } else if (marketingRegion === 'latam' && shouldEventTrigger(latamEvent)) {
      window.dataLayer.push({ event: latamEvent });
    } else if (marketingRegion === 'gsa') {
      pushEvents('GSA', consentSettings);
    } else if (marketingRegion === 'es') {
      pushEvents('ES', consentSettings);
    } else if (marketingRegion === 'uk') {
      pushEvents('UK', consentSettings);
    } else if (marketingRegion === 'br') {
      pushEvents('BR', consentSettings);
    } else if (marketingRegion === 'fr') {
      pushEvents('FR', consentSettings);
    }
  }
  return null;
}

const mapStateToProps = (state) => ({
  marketingRegion: selectors.playbackSession.properties(state).marketingRegion,
  consentSettings: state.applicationinternal.consentSettings,
});

RegionBasedGTMTrigger.propTypes = {
  marketingRegion: PropTypes.string.isRequired,
  consentSettings: PropTypes.objectOf(PropTypes.bool).isRequired,
};

export default connect(mapStateToProps)(RegionBasedGTMTrigger);
